import { SetSockMessagesType } from "../action-types";
import { Reception } from "../actions";

interface ReceptionSockState {
  sockMessage: any;
}

const initialState = {
  sockMessage: {},
};

const ReceptionSockReducer = (
  state: ReceptionSockState = initialState,
  action: Reception
): ReceptionSockState => {
  switch (action.type) {
    case SetSockMessagesType.SET_SOCKMESSAGES:
      return {
        ...state,
        sockMessage: action.payload,
      };
    default:
      return state;
  }
};
export default ReceptionSockReducer;
